// Configure Offset APIs
require("./offset.config.js");

// Include Stylesheet
require("../../css/src/stylesheet.scss");

// Include Offset Base Resources
require("OffsetBaseResources");

// Custom Site Stuff
require("./theme.js");

// Google Places Autocomplete
require("./place-autocomplete.js");

// Material Design
//require("./material-design.js");

// Load via script tag:
// require('script-loader!./scroller.js')

// Expose a variable from a library:
// const scroller = require('expose-loader?scroller!./scroller.js')

// Offset Consent
const { ConsentManager, ConsentUI } = require("offset-consent");
window.OffsetConsent = new ConsentUI(new ConsentManager(window.OFFSET.consent));
window.OffsetConsent.mount();
